import { useForm } from 'react-hook-form';
import { ErrorMessage } from '@hookform/error-message';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { forgetPassword } from '../store/api/CustomerApi';
import { useHistory } from 'react-router-dom'
import Loader from 'react-loader-spinner';
import { Button, Col, Row } from 'react-bootstrap';

const ForgetPassword = (props) => {
    useEffect(() => {
        document.body.classList = "notMain";
    }, [])
    const isLoading = useSelector(state => state.loading?.isLoading)
    const dispatch = useDispatch();
    const { register, errors, handleSubmit } = useForm();
    const history = useHistory();
    const onSubmit = (data) => {
        dispatch(
            forgetPassword(data, () => {
                props.setForgetPassword(false);
                history.push("/");
            })
        );
    }
    const cancelRequest = () => {
        props.setForgetPassword(false);
        history.push("/");
    }
    const checkNationalCode = (Name) => {
        if (Name.length === 10) {
            if (Name === '1111111111' ||
                Name === '0000000000' ||
                Name === '2222222222' ||
                Name === '3333333333' ||
                Name === '4444444444' ||
                Name === '5555555555' ||
                Name === '6666666666' ||
                Name === '7777777777' ||
                Name === '8888888888' ||
                Name === '9999999999') {
                //errors.Name = "Name Is Not Valid";
                return false;
            }
            let c = parseInt(Name.charAt(9));
            let n = parseInt(Name.charAt(0)) * 10 +
                parseInt(Name.charAt(1)) * 9 +
                parseInt(Name.charAt(2)) * 8 +
                parseInt(Name.charAt(3)) * 7 +
                parseInt(Name.charAt(4)) * 6 +
                parseInt(Name.charAt(5)) * 5 +
                parseInt(Name.charAt(6)) * 4 +
                parseInt(Name.charAt(7)) * 3 +
                parseInt(Name.charAt(8)) * 2;
            let r = n - parseInt(n / 11) * 11;
            if (!((r === 0 && r === c) || (r === 1 && c === 1) || (r > 1 && c === 11 - r))) {
                return false;
            }
            else {
                return true;
            }
        }
        else {
            return false;
        }

    }
    return (
        <div className="container-fluid mt-2">
            <br />
            <div className="card">
                <div className="card-header headerStyle">درخواست دوباره رمز عبور</div>
                <div className="card-body bodyStyle">
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <Row>
                            <Col md={2} className="form-group">
                                <label>شماره ملی</label>
                                <input type="text" name="Name" className="form-control" ref={register({ required: true, validate: checkNationalCode })} />
                                {errors.Name && <small className="errors">کد ملی معتبر نیست</small>}
                            </Col>
                            <Col md={2} className="form-group">
                                <label>شماره همراه</label>
                                <input type="text" name="StringValue" className="form-control" ref={register({ required: true })} />
                                {errors.StringValue && <small className="errors">شماره همراه الزامی است</small>}
                            </Col >
                            <Col md={2} className="form-group">
                                <label>&nbsp;</label>
                                {!isLoading ? <Button className="w-100 mt-1">درخواست رمز</Button> : <span> لطفا کمی صبر کنید <Loader type="BallTriangle" color="red" height={20} width={20} /> </span>}
                            </Col>
                            <Col md={2} className="form-group">
                                <label>&nbsp;</label>
                                <Button variant='danger' className="w-100 mt-1" onClick={cancelRequest}>انصراف</Button>
                            </Col>
                        </Row>
                    </form>
                </div>
            </div>

        </div>

    );
}
export default ForgetPassword;